import React, { useContext, useEffect, useState } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { Avatar } from "react-native-elements";
import { useNavigation } from "@react-navigation/native";

import {
  IconIo,
  Content,
  Title,
  ContentButton
} from "./styles";
import { Button, Container, Header, TextField } from "../../components";
import { themes } from "../../design/colors";
import UserContext from "../../context/user";
import AsyncStorage from "@react-native-async-storage/async-storage";
import RouteContext from "../../context/route";

function Success() {
  const navigation = useNavigation();
  const { getRoute, getRouteDriver, finalizeDelivery } = useContext(RouteContext);

  const [loading, setLoading] = useState(false);

  async function handleGetData() {
    setLoading(true);
    const role = await AsyncStorage.getItem('@lmatransportes:role');
      if(role === '1') {
        try {
          await getRoute();
          navigation.navigate('ReportAdmin');
        } catch (_) {
          console.log('error handleGetData screen');
          setLoading(false);
        }
      } else {
        try {
          await getRouteDriver();
          navigation.navigate('DashboardDriver');
        } catch (_) {
          console.log('error handleGetData screen');
          setLoading(false);
        }
      }
      setLoading(false);
  }

  return (
    <Container>
      <Content>
       <IconIo name="checkmark-circle" size={100} color={themes.colors.green1} />
       {finalizeDelivery.order_status !== '1' ? (
        <Title>Problema relatado com sucesso</Title>
       ) : (
        <Title>Entrega finalizada com sucesso</Title>
       )}
      </Content>
      <ContentButton>
        <Button title="Continuar" loading={loading} onPress={handleGetData} />
      </ContentButton>
    </Container>
  );
}

export default Success;
